import { ReactNode } from 'react';
import { FooterLayoutStyled, FooterLayoutBodyStyled } from './styled';

type StickyFooterProps = {
  children: ReactNode;
};

export const StickyFooter = ({ children }: StickyFooterProps) => {
  return (
    <FooterLayoutStyled>
      <FooterLayoutBodyStyled maxWidth="container">{children}</FooterLayoutBodyStyled>
    </FooterLayoutStyled>
  );
};
